export enum IndexGridColumnId {
  INDEX_CHECKBOX = 'INDEX_CHECKBOX',
  INDEX_ACTIONS = 'INDEX_ACTIONS',
  INDEX_STATUS = 'INDEX_STATUS',
  INDEX_DESCRIPTION = 'INDEX_DESCRIPTION',
  INDEX_BLOOMBERG_CODE = 'INDEX_BLOOMBERG_CODE',
  INDEX_VALID_FOR = 'INDEX_VALID_FOR',
  INDEX_PRICE = 'INDEX_PRICE',
  INDEX_ISIN = 'INDEX_ISIN',
  INDEX_BLOOMBERG_INDEX_CODE = 'INDEX_BLOOMBERG_INDEX_CODE',
  INDEX_LAG_AMOUNT = 'INDEX_LAG_AMOUNT',
  INDEX_LAG_TYPE = 'INDEX_LAG_TYPE',
  INDEX_LAST_UPDATED_AT = 'INDEX_LAST_UPDATED_AT',
  INDEX_LAST_UPDATED_BY = 'INDEX_LAST_UPDATED_BY'
}
